import { Swiper } from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const relatedTeamBlocks = document.querySelectorAll('.block-related-team');

if (relatedTeamBlocks.length) {
	const initSwiper = (block) => {
		const swiperContainer = block.querySelector('.swiper');
		const settings = {
			loop: false,
			spaceBetween: 16,
			slidesPerView: 1,
			modules: [Navigation, Pagination],
			navigation: {
				nextEl: block.querySelector('.swiper-button-next'),
				prevEl: block.querySelector('.swiper-button-prev'),
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				768: {
					spaceBetween: 32,
					slidesPerView: 4,
				},
			},
		};

		new Swiper(swiperContainer, settings);
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initSwiper(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	relatedTeamBlocks.forEach((block) => observer.observe(block));
}
